import React from 'react'

export const ThTable = ({titulo, color='bg-blue-900'}) => {
  return (
    <th className={`py-0.5 font-semibold uppercase ${color} text-white border border-gray-300 hidden sm:table-cell`}>{titulo}</th>
  )
}
